import { render } from "./FarbigkeitSquare.vue?vue&type=template&id=4f135072&scoped=true"
import script from "./FarbigkeitSquare.vue?vue&type=script&lang=js"
export * from "./FarbigkeitSquare.vue?vue&type=script&lang=js"

import "./FarbigkeitSquare.vue?vue&type=style&index=0&id=4f135072&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f135072"]])

export default __exports__